{
  "dashboard": {
    "title": "Přehled",
    "subtitle": "Souhrn stavu tvé zahrady"
  },
  "sensors": {
    "title": "Správa čidel",
    "subtitle": "Přehled a seřízení všech čidel v systému",
    "sections": {
      "chemistry": "Chemie roztoku",
      "temperature": "Teplota",
      "levels": "Hladiny",
      "flow": "Průtok",
      "other": "Ostatní"
    },
    "typeLabels": {
      "ph": "Kyselost (pH)",
      "ec": "Síla výživy (EC)",
      "temperature": "Teplota",
      "level": "Hladina",
      "flow": "Průtok"
    },
    "status": {
      "fault": "Porucha",
      "offline": "Nepřipojeno",
      "ok": "Funguje"
    },
    "offlineHint": "Co zkusit: 1) Zkontrolujte kabeláž 2) Ověřte WiFi 3) Restartujte ESP32",
    "calibration": {
      "good": "V pořádku",
      "needed": "Potřebné",
      "error": "Chyba"
    },
    "card": {
      "currentValue": "Aktuální hodnota",
      "calibration": "Seřízení",
      "lastCalibration": "Poslední: {{date}}"
    },
    "actions": {
      "settings": "Nastavení",
      "calibrate": "Seřídit",
      "showTrend": "Zobrazit trend",
      "refresh": "Obnovit"
    },
    "stats": {
      "working": "Funguje",
      "needsCalibration": "Potřebuje seřízení",
      "faults": "Poruchy"
    },
    "loadError": "Chyba při načítání čidel",
    "empty": {
      "title": "Žádná čidla",
      "description": "Přidejte čidla do systému pro jejich správu a seřízení. Čidla se automaticky detekují po připojení zařízení.",
      "action": "Obnovit seznam"
    }
  },
  "controls": {
    "title": "Ovládání systému",
    "subtitle": "Manuální ovládání všech zařízení ({{count}} přístrojů)"
  },
  "cycle": {
    "title": "Aeroponický cyklus čerpadla",
    "onTime": "Délka sepnutí (ON)",
    "onHint": "Jak dlouho čerpadlo v každém cyklu běží.",
    "offTime": "Pauza (OFF)",
    "offHint": "Prodleva mezi sepnutími. Cyklus = ON + pauza."
  },
  "nightMode": {
    "title": "Noční režim čerpadla",
    "description": "V nočním okně běží čerpadlo na sníženém výkonu pro tišší a šetrnější provoz.",
    "on": "Zapnuto",
    "off": "Vypnuto",
    "start": "Začátek",
    "end": "Konec",
    "power": "Výkon čerpadla",
    "powerHint": "Doporučeno 25–40 %.",
    "kickstart": "Kickstart (rozběh)",
    "kickstartHint": "Krátký výkonový impuls pro rozjezd čerpadla. Doporučeno 50 % (tišší než 100 %).",
    "duration": "Délka běhu",
    "durationHint": "Při nižším výkonu nech čerpadlo běžet déle (stejný objem).",
    "save": "Uložit",
    "saved": "Noční režim uložen",
    "saveFailed": "Uložení nočního režimu selhalo",
    "statusTitle": "Cyklus čerpadla",
    "lastRun": "Poslední spuštění",
    "nextRun": "Příští spuštění",
    "runDuration": "Délka běhu",
    "never": "Nikdy",
    "soon": "Každou chvíli"
  },
  "dosing": {
    "title": "Výživa rostlin",
    "subtitle": "Automatické dávkování živin a úprava pH pro optimální růst",
    "calibration": {
      "title": "Kalibrace čerpadla",
      "subtitle": "Změř skutečný průtok a uloží se kalibrační křivka.",
      "back": "Zpět",
      "next": "Pokračovat",
      "cancel": "Zrušit",
      "save": "Uložit kalibraci",
      "runNow": "Spustit",
      "again": "Znovu",
      "addPoint": "Přidat bod",
      "pump": "Čerpadlo",
      "lastCal": "Poslední kalibrace",
      "never": "Nikdy",
      "preview": "Náhled",
      "steps": {
        "pick": "Čerpadlo",
        "prime": "Naplnit hadičku",
        "measure": "Měření",
        "review": "Souhrn"
      },
      "pick": {
        "title": "Vyber čerpadlo ke kalibraci",
        "subtitle": "Zobrazují se připojená dávkovací čerpadla na hubu.",
        "calibrated": "Zkalibrováno",
        "cleanReminder": "Před kalibrací propláchni čistou vodou (1 min)."
      },
      "prime": {
        "title": "Naplnit hadičku a připravit nádobu",
        "subtitle": "Zajistí přesné výsledky bez vzdušných bublin.",
        "checklist": "Kontrolní seznam",
        "ck1": {
          "t": "Hadička je ponořena v roztoku",
          "h": "Inlet musí být pod hladinou."
        },
        "ck2": {
          "t": "Odtoková strana je nad nádobkou",
          "h": "Připrav kalibrační nádobku."
        },
        "ck3": {
          "t": "Naplnit čerpadlo (prime)",
          "h": "Klikni na tlačítko níže."
        },
        "ck4": {
          "t": "Hadička je plná, bez bublin",
          "h": "Vizuálně zkontroluj průhledné hadičky."
        },
        "primeBtn": "Naplnit (10 s)",
        "primed": "Hotovo. Hadička je plná.",
        "priming": "Plním…",
        "densityToggle": "Hustota roztoku",
        "densityHint": "g/ml · výchozí 1,00 (voda)",
        "tickAll": "Zaškrtni vše pro pokračování",
        "tipTitle": "Tip",
        "tip": "Po naplnění se ujisti, že z hadičky kape rovnoměrně."
      },
      "measure": {
        "title": "Změř skutečný průtok",
        "subtitle": "Spusť čerpadlo a zadej objem z kalibrační nádobky.",
        "pwm": "Výkon (PWM)",
        "runFor": "Délka běhu",
        "runHint": "Delší doba dává přesnější výsledek.",
        "pwmHint": "Změř průtok na 25/50/75/100 % pro kalibrační křivku.",
        "live": "Běží",
        "done": "Hotovo",
        "ready": "Připraveno",
        "target": "Odhad",
        "measured": "Naměřený objem",
        "measuredHint": "Přečti z kalibrační nádobky po ukončení.",
        "points": "Naměřené body",
        "noPoints": "Zatím žádné body. Spusť test a přidej bod.",
        "pwmCovered": "PWM pokryto",
        "tryNext": "Doporučené PWM:",
        "avgRate": "Průměrný průtok",
        "curve": "Kalibrační křivka"
      },
      "review": {
        "title": "Hotovo. Zkontroluj a ulož.",
        "subtitle": "Porovnání s předchozí kalibrací.",
        "old": "Stávající",
        "new": "Nová",
        "change": "Změna",
        "vsOld": "vs. předchozí kalibrace",
        "curveType": "Typ křivky",
        "pwmCurve": "PWM křivka",
        "linear": "Lineární",
        "multiPoint": "Vícehodová",
        "points": "bodů",
        "consistency": "Konzistence",
        "excellent": "Výborná",
        "good": "Dobrá",
        "poor": "Slabá",
        "auditTrail": "Záznam v journalu",
        "auditOn": "Kalibrace se zapíše do deníku.",
        "notes": "Poznámka",
        "notesPh": "Volitelná poznámka ke kalibraci…"
      }
    }
  },
  "automation": {
    "title": "Automatická péče",
    "subtitle": "Nastav si, jak bude systém reagovat na změny prostředí",
    "rulesSubtitle": "Automatické reakce na hodnoty čidel a stavy zařízení",
    "newRule": "Nové pravidlo",
    "templatesTitle": "Šablony pro rychlý start",
    "views": {
      "rules": "Pravidla",
      "history": "Historie",
      "analytics": "Analytika"
    },
    "stats": {
      "activeRules": "Aktivní pravidla",
      "ofTotal": "z {{total}}",
      "runningNow": "Právě běží",
      "rulesUnit": "pravidel",
      "idle": "v klidu",
      "runs": "Spuštění",
      "total": "celkem",
      "analytics": "Analytika",
      "show": "zobrazit"
    },
    "filters": {
      "all": "Vše",
      "enabled": "Aktivní",
      "running": "Běží"
    },
    "running": {
      "title": "Právě běží",
      "phase": "Krok {{current}} z {{total}}",
      "inProgress": "Probíhá…",
      "finishesIn": "doběhne za {{time}}"
    },
    "history": {
      "title": "Historie běhů",
      "empty": "Zatím žádné běhy",
      "emptyDesc": "Jakmile se nějaké pravidlo spustí, uvidíš ho tady.",
      "filterAll": "Vše",
      "success": "Úspěch",
      "failed": "Chyba",
      "running": "Běží",
      "prev": "Předchozí",
      "next": "Další",
      "pageInfo": "Strana {{page}} z {{total}}"
    },
    "analytics": {
      "title": "Analytika",
      "empty": "Žádná data",
      "emptyDesc": "Pro zvolené období nejsou žádné běhy.",
      "totalRuns": "Spuštění celkem",
      "successRate": "Úspěšnost",
      "failedRuns": "Chyby",
      "runsPerDay": "Spuštění po dnech",
      "topRules": "Nejaktivnější pravidla",
      "daysShort": "{{count}} dní"
    },
    "detail": {
      "logic": "Logika",
      "runs": "Spuštění",
      "priority": "Priorita",
      "active": "Aktivní",
      "paused": "Pozastaveno",
      "state": "Stav",
      "lastRun": "Poslední spuštění",
      "severity": "Závažnost",
      "recentRuns": "Poslední běhy",
      "noRecentRuns": "Zatím žádné běhy",
      "edit": "Upravit",
      "duplicate": "Duplikovat",
      "pause": "Pozastavit",
      "resume": "Obnovit",
      "parameters": "Parametry",
      "trigger": "Spouštěč",
      "sensor": "Senzor",
      "condition": "Podmínka",
      "hysteresis": "Hystereze",
      "sustained": "Trvání podmínky",
      "action": "Akce",
      "actuator": "Aktor",
      "duration": "Doba běhu",
      "message": "Zpráva",
      "cooldown": "Cooldown",
      "blockedModes": "Blokováno v režimech",
      "steps": "Kroky",
      "sequenceSteps": "Sekvence ({{count}} kroků)",
      "deviceOn": "Při zapnutí zařízení",
      "deviceOff": "Při vypnutí zařízení",
      "category": "Kategorie"
    },
    "duplicate": {
      "copyName": "{{name}} (kopie)",
      "success": "Pravidlo zduplikováno",
      "safetyUnsupported": "Duplikace pojistek zatím není podporována"
    },
    "aeroponic": {
      "title": "Aeroponický cyklus",
      "subtitle": "Perpetuální mlžení řízené firmwarem (přežije restart serveru)",
      "enabled": "Aktivní",
      "disabled": "Vypnuto",
      "pump": "Čerpadlo",
      "solenoid": "Solenoid (ventil)",
      "solenoidNone": "Žádný",
      "onTime": "Doba běhu (ON)",
      "offTime": "Pauza (OFF)",
      "save": "Uložit a aplikovat",
      "saved": "Cyklus uložen a odeslán do zařízení",
      "runningInfo": "Běží: {{on}} ON / {{off}} OFF — řízeno firmwarem",
      "note": "Běží přímo na zařízení, nezávisle na serveru. Nahrazuje staré mlžení přes pravidlo.",
      "pumps": {
        "suction": "Sací čerpadlo",
        "phPlus": "Čerpadlo pH+",
        "phMinus": "Čerpadlo pH−",
        "nutrientA": "Čerpadlo Hnojivo A",
        "nutrientB": "Čerpadlo Hnojivo B"
      },
      "solenoids": {
        "pb0": "Větev k rostlinám",
        "pb1": "Bypass",
        "pb2": "Chladící smyčka"
      },
      "units": {
        "sec": "s",
        "min": "min"
      },
      "power": "Výkon čerpadla",
      "kickstart": "Kickstart (rozběh)",
      "kickstartHint": "Krátký burst pro rozjezd; dolaď pozorováním (0 = vypnuto)",
      "nightMode": "Noční režim",
      "nightStart": "Začátek",
      "nightEnd": "Konec",
      "nightPower": "Noční výkon"
    },
    "disinfection": {
      "title": "Desinfekce",
      "subtitle": "Denní noční ozonizace + míchání (řízeno firmwarem)",
      "enabled": "Aktivní",
      "disabled": "Vypnuto",
      "startTime": "Čas spuštění",
      "duration": "Délka běhu",
      "minutes": "min",
      "actuators": "Zařízení",
      "ozonizer": "Ozonizer",
      "mixer": "Míchání",
      "note": "Spustí se 1× denně v daný čas; firmware aktory sám po uplynutí vypne.",
      "save": "Uložit",
      "saved": "Desinfekce uložena",
      "runNow": "Spustit teď",
      "runStarted": "Desinfekce spuštěna"
    }
  },
  "safety": {
    "title": "Hlídači",
    "subtitle": "Automatická ochrana tvého systému a rostlin."
  },
  "batches": {
    "title": "Moje výsadby",
    "subtitle": "Správa a sledování pěstovacích cyklů"
  },
  "journal": {
    "title": "Pěstební deník",
    "subtitle": "Záznamy a pozorování tvých výsadeb"
  },
  "recipes": {
    "title": "Pěstební recepty",
    "subtitle": "Pojmenuj fáze růstu a hnojení pro tvé plodiny",
    "presetsTitle": "Dávkovací tabulky (Šablony)",
    "presetsSubtitle": "Katalog hnojivových schémat od výrobců — použij jako základ pro nový recept",
    "createRecipe": "Vytvořit recept",
    "newTable": "Nová tabulka",
    "cardTitle": "Růstové recepty a výrobní šablony",
    "cardDesc": "Stránka spojuje vlastní recepty, dávkovací tabulky a vícestupňové fáze růstu do jednoho návrhu.",
    "tabMyRecipes": "Moje recepty",
    "tabRecipes": "Recepty",
    "tabManufacturerTemplates": "Šablony výrobců",
    "tabTemplates_zero": "{{count}} šablon",
    "tabTemplates_one": "{{count}} šablona",
    "tabTemplates_few": "{{count}} šablony",
    "tabTemplates_other": "{{count}} šablon",
    "countRecipes_zero": "{{count}} receptů",
    "countRecipes_one": "{{count}} recept",
    "countRecipes_few": "{{count}} recepty",
    "countRecipes_other": "{{count}} receptů",
    "editorOpen": "Editor otevřen",
    "overviewActive": "Přehled je aktivní",
    "myRecipesTab": "Moje recepty ({{count}})",
    "templatesTab": "Šablony výrobců ({{count}})",
    "emptyTitle": "Nemáš žádné pěstební recepty",
    "emptyDesc": "Vytvoř si svůj první recept nebo použij dávkovací tabulku jako šablonu.",
    "noDescription": "Bez popisu",
    "growthPhases": "Fáze růstu",
    "days": "dní",
    "emptyTemplatesTitle": "Nemáš žádné dávkovací tabulky",
    "emptyTemplatesDesc": "Vytvoř nové hnojivové schéma nebo importuj od výrobce.",
    "addFirstTable": "Přidej první tabulku",
    "phases_zero": "{{count}} fází",
    "phases_one": "{{count}} fáze",
    "phases_few": "{{count}} fáze",
    "phases_other": "{{count}} fází",
    "ingredients": "složek",
    "useAsTemplate": "Použij jako šablonu",
    "editRecipe": "Uprav recept",
    "newRecipeTitle": "Nový pěstební recept",
    "fieldName": "Název",
    "namePlaceholder": "např. Rajčatový recept",
    "fieldPlantType": "Druh rostliny",
    "fieldDescription": "Popis",
    "addPhase": "Přidej fázi",
    "phaseN": "Fáze {{num}}",
    "fieldPhaseName": "Název Fáze",
    "fieldDuration": "Délka (dny)",
    "fieldLight": "Světlo (hod)",
    "hintLight": "Typicky 12–18 hodin",
    "fieldMinPh": "Min pH",
    "hintPh": "Většina zeleniny: 5.5–6.5",
    "fieldMaxPh": "Max pH",
    "fieldMinEc": "Min EC",
    "hintEcLeafy": "Listová zelenina: 0.8–1.5 mS/cm",
    "fieldMaxEc": "Max EC",
    "hintEcFruit": "Plodová zelenina: 2.0–3.0 mS/cm",
    "fieldMinTemp": "Min Teplota",
    "hintTemp": "Většina plodin: 18–28 °C",
    "fieldMaxTemp": "Max Teplota",
    "nutrientsTitle": "Hnojiva / Aditiva (na 10l vody)",
    "addIngredient": "Přidej složku",
    "selectFertilizer": "Vyber hnojivo...",
    "placeholderAmount": "Množství",
    "placeholderUnit": "Jednotka",
    "noNutrients": "Nemáš žádná hnojiva pro tuto fázi.",
    "pickFromTemplates": "Vyber si z šablon",
    "cancel": "Zruš to",
    "saveChanges": "Ulož  změny",
    "confirmDeleteTitle": "Opravdu chcešsmazat recept?",
    "confirmDeleteText": "Tato akce je nevratná. Recept bude trvale odstraněn.",
    "delete": "Smaž to",
    "confirmDeleteTableTitle": "Smaž dávkovací tabulku?",
    "confirmDeleteTableText": "Opravdu chceš smazat tuto dávkovací tabulku? Tato akce je nevratná.",
    "toastLoadError": "Nepodařilo se mi načíst recepty.",
    "toastLoadTablesError": "Nepodařilo se mi načíst dávkovací tabulky.",
    "toastTableDeleted": "Tabulka byla smazána",
    "toastTableDeleteError": "Při mazání tabulky došlo k chybě. Zkuste to znovu.",
    "toastTableUpdated": "Tabulka byla aktualizována",
    "toastTableCreated": "Tabulka byla vytvořena",
    "toastTableSaveError": "Při ukládání tabulky došlo k chybě. Zkuste to znovu.",
    "toastTemplateLoaded": "Šablona \"{{name}}\" se načetla do nového receptu",
    "toastNameRequired": "Vyplňte název receptu",
    "toastRecipeUpdated": "Recept byl aktualizován",
    "toastRecipeCreated": "Recept byl vytvořen",
    "toastRecipeSaveError": "Při ukládání receptu došlo k chybě. Zkuste to znovu.",
    "toastRecipeDeleted": "Recept byl smazán",
    "toastRecipeDeleteError": "Při mazání receptu došlo k chybě. Zkuste to znovu.",
    "plantTypes": {
      "lettuce": "Salátová zelenina",
      "tomato": "Rajčatová zelenina",
      "pepper": "Papriky & Chilli",
      "herb": "Bylinky (Bazalka atd.)",
      "cannabis": "Léčebné Konopí",
      "flower": "Okrasné květiny",
      "other": "Ostatní"
    },
    "defaultPhaseName": "Nová Fáze",
    "defaultFirstPhaseName": "Sazenice",
    "templateSuffix": "(Šablona)"
  },
  "nutrientPresets": {
    "title": "Dávkovací tabulky",
    "subtitle": "Katalog hnojících schémat pro tvoje pěstební výsadby."
  },
  "reservoirs": {
    "title": "Nádrže",
    "subtitle": "Spravuj nádrže pro zařízení {{device}}",
    "form": {
      "nameRequired": "Nádrž se musí nějak jmenovat",
      "nameLabel": "Název nádrže *",
      "capacityLabel": "Objem (litry)",
      "cancel": "Zruš",
      "save": "Ulož",
      "create": "Vytvoř",
      "addTitle": "Nová nádrž",
      "editTitle": "Uprav nádrž"
    },
    "card": {
      "default": "Výchozí",
      "hideSensors": "Skryj čidla",
      "showSensors": "Zobraz čidla",
      "editTitle": "Uprav nádrž",
      "deleteTitle": "Smaž nádrž",
      "dosingTitle": "Dávkování",
      "assignedSensors": "Přiřazená čidla",
      "removeSensorTitle": "Odeber čidlo z nádrže",
      "addSensorTitle": "Přiřaď čidlo k nádrži",
      "noSensors": "Nejsou žádná čidla přiřazena k této nádrži.",
      "availableSensors": "Dostupná čidla (nepřiřazená)",
      "allSensorsAssigned": "Všechna čidla jsou již přiřazena.",
      "sensorAssigned": "Čidlo bylo přiřazeno k nádrži",
      "sensorAssignFailed": "Při přiřazení čidla došlo k chybě",
      "sensorUnassigned": "Čidlo bylo odebráno z nádrže",
      "sensorUnassignFailed": "Při odebírání čidla došlo k chybě"
    },
    "noDevice": {
      "subtitle": "Nádrže jsou součástí zařízení, proto nejdřív připoj nebo přiřaď zařízení.",
      "title": "Žádné zařízení",
      "description": "Nejdříve přiřaď zařízení k tvému účtu. Nádrže se vytvářejí k zařízení."
    },
    "overview": {
      "title": "Přehled správy nádrží",
      "activeDevice": "Aktivní zařízení: {{device}}",
      "reservoirCount": "{{count}} nádrží",
      "defaultReservoir": "Výchozí: {{name}}",
      "noDefault": "Bez výchozí nádrže",
      "assignedSensors": "{{count}} přiřazených čidel"
    },
    "actions": {
      "add": "Přidej nádrž"
    },
    "empty": {
      "title": "Žádné nádrže",
      "description": "Vytvoř první nádrž pro tvoje zařízení. Nádrže slouží k monitorování hladiny, pH a EC roztoku.",
      "create": "Vytvoř nádrž",
      "dosing": "Přejdi na dávkování"
    },
    "infoTip": "Kliknutím na šipku u nádrže zobrazíš a přiřadíš čidla. Nádrž přiřadíš k záhonu v jeho nastavení (Moje záhony → upravit).",
    "delete": {
      "title": "Smazat nádrž?",
      "confirmText": "Smaž",
      "description": "Opravdu chceš smazat nádrž \"{{name}}\"? Tato akce je nevratná a odstraní všechna data spojená s touto nádrží."
    },
    "toasts": {
      "created": "Nádrž byla vytvořena",
      "duplicateIndex": "Nádrž s tímto indexem již existuje",
      "createFailed": "Při vytváření nádrže došlo k chybě",
      "updated": "Nádrž byla aktualizována",
      "updateFailed": "Při aktualizaci nádrže došlo k chybě",
      "deleted": "Nádrž byla smazána",
      "deleteFailed": "Při mazání nádrže došlo k chybě"
    }
  },
  "tasks": {
    "title": "Úkoly",
    "subtitle": "Kalendář a seznam úkolů"
  },
  "cropPlans": {
    "title": "Plány pěstování",
    "subtitle": "Plánuj a sleduj své pěstební cykly"
  },
  "cropPlanList": {
    "status": {
      "draft": "Koncept",
      "active": "Aktivní",
      "completed": "Dokončeno",
      "archived": "Archivováno"
    },
    "card": {
      "createdBadge": "Vytvořeno {{date}}",
      "activateTitle": "Aktivovat plán",
      "completeTitle": "Dokonči",
      "archiveTitle": "Archivuj",
      "editTitle": "Uprav",
      "deleteTitle": "Smaž",
      "noDescription": "Bez popisu",
      "created": "Vytvořeno: {{date}}",
      "start": "Start: {{date}}"
    },
    "actions": {
      "fromPast": "Historické plány",
      "templates": "Šablony",
      "new": "Nový plán"
    },
    "overview": {
      "title": "Přehled pěstebních plánů",
      "total": "{{count}} celkem",
      "active": "{{count}} aktivních",
      "completed": "{{count}} dokončených",
      "activeFilter": "Aktivní filtr:"
    },
    "filter": {
      "all": "Vše",
      "draft": "Koncepty",
      "active": "Aktivní",
      "completed": "Dokončené",
      "archived": "Archiv"
    },
    "empty": {
      "allTitle": "Žádné plány",
      "filteredTitle": "Žádné plány ve filtru {{filter}}",
      "allDescription": "Vytvoř si svůj první pěstební plán pro organizaci pěstování.",
      "filteredDescription": "Aktuálně tu teď žádný plán není. Přepni filtr nebo založ nový plán.",
      "createAction": "Vytvoř nový plán",
      "showAllAction": "Zobraz všechny plány",
      "fromPastAction": "Použij historické plány"
    },
    "delete": {
      "title": "Smazat plán?",
      "description": "Opravdu chceš smazat tento plán pěstování? Tato akce je nevratná.",
      "confirmText": "Smaž",
      "cancelText": "Zruš"
    },
    "pastPlan": {
      "modalTitle": "Vytvoř si kopii ze starého plánu",
      "description": "Zkopíruj všechny rostliny a množství z vybraného dřívějšího plánu. Můžeš si tak snadno zopakovat loňskou výsadbu s novým datem začátku.",
      "selectLabel": "Vyber proběhlý plán",
      "selectPlaceholder": "-- Vyber plán --",
      "nameLabel": "Název nového plánu",
      "namePlaceholder": "Např. Letní záhon 2026",
      "startLabel": "Předpokládaný začátek (Start Date)",
      "startHint": "Datum, od kterého se budou počítat kroky pěstování v tomto novém plánu.",
      "cancel": "Zruš",
      "create": "Kopíruj",
      "defaultName": "Kopie starého plánu"
    },
    "toasts": {
      "deleted": "Plán byl úspěšně smazán",
      "deleteFailed": "Při mazání plánu došlo k chybě",
      "activated": "Plán byl úspěšně aktivován",
      "activateFailed": "Při aktivaci plánu došlo k chybě",
      "completed": "Plán byl označen jako dokončený",
      "completeFailed": "Při dokončování plánu došlo k chybě",
      "archived": "Plán byl archivován",
      "archiveFailed": "Při archivaci plánu došlo k chybě",
      "fillAll": "Vyplň prosím všechny údaje",
      "copied": "Nový plán byl úspěšně zkopírován!",
      "copyFailed": "Při kopírování plánu došlo k chybě"
    }
  },
  "settings": {
    "title": "Nastavení",
    "subtitle": "Přizpůsob si nastavení svého hydroponického systému a bezpečnost svého účtu"
  },
  "profile": {
    "title": "Můj profil",
    "subtitle": "Spravuj svůj účet a své nastavení"
  },
  "notifications": {
    "title": "Upozornění a systémové alerty",
    "subtitle": "Sleduj a spravuj systémové události a kritické stavy svého hydroponického systému."
  },
  "analytics": {
    "title": "Analytika",
    "subtitle": "Detailní analýzy a historická data z tvého hydroponického systému"
  },
  "plantopedia": {
    "title": "Plant-O-Pedia",
    "subtitle": "Encyklopedie rostlin, škůdců a pěstebních postupů.",
    "tabs": {
      "plants": "Rostliny",
      "pests": "Škůdci",
      "gnn": "Automatické Predikce"
    },
    "search": "Hledej rostliny...",
    "searchPests": "Hledej škůdce...",
    "filterCategory": "Kategorie",
    "filterDifficulty": "Obtížnost",
    "resultCount_one": "{{count}} rostlina byla nalezena",
    "resultCount_few": "{{count}} rostliny byly nalezeny",
    "resultCount_other": "{{count}} rostlin byly nalezeny",
    "pestResultCount_one": "{{count}} škůdce byl nalezen",
    "pestResultCount_few": "{{count}} škůdci byli nalezeni",
    "pestResultCount_other": "{{count}} škůdců bylo nalezeno",
    "noResults": "Nic nenalezeno",
    "noResultsHint": "Zkus upravit filtry nebo hledaný výraz.",
    "beginnerSection": "Doporučené pro začátečníky",
    "addSpecies": "Přidej druh",
    "detail": {
      "tabs": {
        "overview": "Přehled",
        "growth": "Růst",
        "conditions": "Podmínky",
        "health": "Zdraví",
        "varieties": "Odrůdy"
      },
      "edit": "Uprav",
      "back": "Zpět na seznam",
      "scientificName": "Latinský název",
      "difficulty": "Obtížnost",
      "category": "Kategorie",
      "lifecycle": "Životní cyklus",
      "sowingPeriod": "Období výsevu",
      "harvestPeriod": "Období sklizně",
      "height": "Výška rostliny",
      "companions": "Společníci",
      "pests": "Škůdci a nemoci",
      "noData": "Data nejsou k dispozici"
    },
    "form": {
      "newSpecies": "Nový druh",
      "editSpecies": "Editace druhu",
      "step1": "Základní info",
      "step2": "Růst & Výsev",
      "step3": "Fáze",
      "step4": "Škůdci & Sousedé",
      "step5": "Kontext & Souhrn",
      "name": "Název",
      "namePlaceholder": "Např. Rajče",
      "nameRequired": "Povinné pole",
      "scientificName": "Latinský název",
      "description": "Popis",
      "descriptionPlaceholder": "Charakteristika druhu...",
      "category": "Kategorie",
      "lifecycle": "Životní cyklus",
      "annual": "Jednoletá",
      "perennial": "Víceletá",
      "biennial": "Dvouletá",
      "difficulty": "Obtížnost pěstování",
      "difficultyLabels": [
        "Trivální",
        "Snadné",
        "Střední",
        "Náročné",
        "Velmi náročné"
      ],
      "sowingGeneral": "Období Výsevu (Obecné)",
      "sowingIndoor": "Výsev Doma",
      "sowingOutdoor": "Výsev Venku",
      "harvestPeriod": "Období Sklizně",
      "plantHeight": "Výška rostliny",
      "needsSupport": "Vyžaduje oporu",
      "spacing": "Doporučený spon",
      "spacingPlaceholder": "Např. 40x50 cm",
      "sowingDepth": "Hloubka výsevu",
      "surfaceSowing": "Výsev pouze na povrch (nezasypávat)",
      "growthType": "Typ růstu",
      "pestsTitle": "Škůdci a Nemoci",
      "addPest": "Přidej záznam",
      "noPests": "Zatím žádní evidovaní škůdci ani nemoci.",
      "addFirstPest": "Přidej první záznam",
      "pestCategoryPests": "Škůdci (Hmyz, ptáci, hlemýždi...)",
      "pestCategoryDiseases": "Nemoci (Houby, bakterie, viry)",
      "propagateCompanions": "Aktualizuj i záznamy sousedů",
      "propagateHint": "Pokud zaškrtneš, vybraným druhům se automaticky upraví jejich seznamy tak, aby zahrnovaly tento druh jako svého souseda.",
      "contextGreenhouse": "Skleník",
      "contextOutdoor": "Venku",
      "contextHydroponic": "Hydroponie",
      "contextTitle": "Kde pěstovat (Kontext)",
      "summary": "Souhrn",
      "summaryName": "Název",
      "summaryLatin": "Latinský",
      "summaryHeight": "Výška",
      "summaryPhases": "Fáze",
      "summaryPhaseDefined": "definováno",
      "summaryPests": "Škůdci",
      "summaryPestRecords": "záznamů",
      "prev": "Zpět",
      "next": "Další",
      "save": "Ulož",
      "delete": "Smaž",
      "aiSuggest": "AI Staré",
      "aiEnrich": "AI Obohatit",
      "aiHelp": "AI pomoc",
      "aiHelpDesc": "doplňte parametry",
      "aiPests": "AI škůdci",
      "aiSearching": "Hledám…",
      "deletePestTitle": "Smazat škůdce?",
      "deletePestDesc": "Opravdu chceš smazat tohoto škůdce ze seznamu?",
      "deleteSpeciesTitle": "Smazat druh?",
      "deleteSpeciesDesc": "Opravdu chceš smazat druh \"{{name}}\"? Tato akce je nevratná.",
      "uploadImage": "Kliknutím nahraješ obrázek"
    },
    "categories": {
      "vegetable": "Zelenina",
      "herb": "Bylinka",
      "fruit": "Ovoce",
      "flower": "Květina"
    }
  },
  "devices": {
    "title": "Moje zařízení",
    "subtitle": "{{count}} zařízení je registrováno",
    "noDevices": "Zatím tu nejsou žádná zařízení"
  },
  "hardwareOverview": {
    "header": "Přehled hardwaru",
    "totalSensors": "Celkem čidel",
    "online": "Aktivních",
    "offlineError": "Neaktivních / Chyba",
    "systemStatus": "Stav systému",
    "refreshData": "Obnovit data",
    "errorLoading": "Chyba při načítání hardware dat",
    "lastUpdate": "Poslední update"
  },
  "login": {
    "subtitle": "Přihlaste se do svého hydroponického systému",
    "createAccount": "Vytvořte si nový účet",
    "loginTab": "Přihlášení",
    "registerTab": "Registrace",
    "email": "E-mailová adresa",
    "password": "Heslo",
    "loginButton": "Přihlaš se",
    "registerButton": "Zaregistruj se",
    "forgotPassword": "Zapomněl jsi heslo?",
    "name": "Jméno",
    "namePlaceholder": "Vaše jméno",
    "emailPlaceholder": "vas@email.cz",
    "passwordPlaceholder": "Minimálně 8 znaků",
    "confirmPassword": "Potvrzení hesla",
    "confirmPasswordPlaceholder": "Zopakujte heslo",
    "require2FA": "Jako administrátor musíš aktivovat dvoufaktorovou autentizaci."
  },
  "forgotPassword": {
    "title": "Obnova hesla",
    "subtitle": "Zadejte svou emailovou adresu a my vám pošleme odkaz pro obnovu hesla",
    "emailSent": "Email odeslán",
    "checkInbox": "Zkontroluj svou emailovou schránku",
    "sentMessage": "Pokud existuje účet s touto emailovou adresou, odeslali jsme ti pokyny pro obnovu hesla.",
    "noEmail": "Neobdržel jsi email? Zkontroluj složku spam nebo zkus odeslat znovu.",
    "sendAgain": "Odešli znovu",
    "sendLink": "Odešli odkaz pro obnovu",
    "backToLogin": "Vrať se na přihlášení"
  },
  "resetPassword": {
    "title": "Nové heslo",
    "subtitle": "Zadej své nové heslo",
    "changed": "Heslo změněno",
    "changedSubtitle": "Tvé heslo bylo úspěšně změněno",
    "changedMessage": "Heslo bylo úspěšně změněno. Nyní se můžeš přihlásit s novým heslem.",
    "goToLogin": "Přejdi na přihlášení",
    "invalidLink": "Neplatný odkaz",
    "invalidLinkDesc": "Odkaz pro obnovu hesla je neplatný nebo expiroval. Zkus požádat o nový.",
    "requestNew": "Požádej o nový odkaz",
    "newPassword": "Nové heslo (min. 8 znaků)",
    "confirmPassword": "Potvrď heslo",
    "setNewPassword": "Nastav si nové heslo",
    "backToLogin": "Vrať se na přihlášení"
  },
  "help": {
    "glossaryTitle": "Slovníček pojmů",
    "glossarySubtitle": "Všechny důležité pojmy na jednom místě — pro lepší orientaci v hydroponickém pěstování",
    "searchPlaceholder": "Hledej pojem...",
    "noResults": "Žádný pojem nenalezen",
    "tryDifferent": "Zkus jiný hledaný výraz",
    "example": "Příklad",
    "categoryBasics": "Základy hydroponie",
    "categorySystems": "Typy systémů",
    "categoryMeasurement": "Měření a čidla",
    "categoryOperation": "Provoz a údržba"
  },
  "schedule": {
    "title": "Plánovač úloh",
    "subtitle": "Spravuj automatické úlohy a plánované akce vašeho systému"
  },
  "admin": {
    "title": "Administrace",
    "subtitle": "Správa systému",
    "users": "Správa uživatelů",
    "usersSubtitle": "Správa uživatelských účtů a oprávnění",
    "devices": "Správa zařízení",
    "devicesSubtitle": "Správa připojených zařízení",
    "firmware": "Správa firmware",
    "firmwareSubtitle": "OTA aktualizace a správa firmware verzí",
    "hardware": "Hardware metriky",
    "hardwareSubtitle": "Přehled stavu hardwaru a systémových metrik",
    "audit": "Audit log",
    "auditSubtitle": "Historie systémových událostí",
    "knowledgeSources": "Znalostní zdroje",
    "knowledgeSourcesSubtitle": "Správa zdrojů pro RAG pipeline a automatické ověřování companion planting vztahů"
  },
  "branches": {
    "title": "Pěstební záhony",
    "subtitle": "Správa pěstebních větví",
    "listSubtitle": "Spravuj pěstební plochy, záhony a jejich výsadby.",
    "newBranch": "Založ nový záhon",
    "editBranch": "Uprav záhon",
    "newGrowingBranch": "Nový pěstební záhon",
    "automated": "Automatizovaný",
    "manual": "Manuální (Bez zařízení)",
    "automatedBranches": "Automatizované Záhony",
    "manualBranches": "Manuální Záhony",
    "activePosition": "Aktivní pozice",
    "disabledSlot": "Vypnuto (Prázdné místo)",
    "addBranch": "Přidej záhon",
    "limitReached": "Limit záhonů dosažen",
    "gridLayout": "Rozložení a Tvar (Grid Layout)",
    "columns": "Počet sloupců (šířka)",
    "rows": "Počet řádků (výška)",
    "activeCapacity": "Aktivní Kapacita",
    "assignedLighting": "Přiřazené Osvětlení",
    "assignedValves": "Přiřazené Ventily",
    "branchControls": "Ovládání Větve",
    "lighting": "Osvětlení",
    "valves": "Ventily",
    "targetConditions": "Cílové Podmínky",
    "fromActiveRecipes": "Dle aktivních receptů",
    "activePlants": "Aktivní Rostliny / Výsadby",
    "plantingHistory": "Historie výsadeb",
    "noHistory": "Žádná historie.",
    "rackView": "Osazení (Rack)",
    "statusHealthy": "Zdravá",
    "statusSick": "Nemocná",
    "statusDead": "Mrtvá",
    "noActiveDevice": "Není vybráno žádné aktivní zařízení.",
    "selectDeviceForAutomated": "Vyberte zařízení pro zobrazení automatizovaných záhonů.",
    "hwIndex": "HW Index",
    "outputNum": "Výstup #{{num}}",
    "outputTaken": "(Obsazeno)",
    "manualNotConnected": "Manuální záhon není připojen k žádnému výstupu zařízení.",
    "noLightsFound": "Žádná světla nebyla nalezena.",
    "noValvesFound": "Žádné ventily nebyly nalezeny.",
    "optionalDescription": "Volitelný popis...",
    "namePlaceholder": "Např. Levá strana",
    "saveChanges": "Ulož změny",
    "deleteBranchTitle": "Smazat záhon?",
    "deleteBranchDesc": "Opravdu chceš smazat tento záhon? Tato akce je nevratná a odstraní všechna data historie spojená s tímto záhonem.",
    "maxBranchesPerDevice": "Max: {{max}} záhonů na zařízení",
    "noManualBranches": "Žádné manuální záhony",
    "manualBranchesDesc": "Manuální záhony slouží k evidenci rostlin bez automatizace.",
    "addManualBranch": "Přidej manuální záhon",
    "clickToToggle": "Pozice #{{slot}} - Kliknutím {{action}}",
    "enable": "povolit",
    "disableAction": "vypnout",
    "clickToShape": "Kliknutím na čtverečky vytvoříš nepravidelný tvar (vynecháte místa).",
    "noDescription": "Bez popisu",
    "temperature": "Teplota",
    "humidity": "Vlhkost",
    "light": "Světlo",
    "nothingGrowing": "Na této větvi nic neroste.",
    "createNewPlanting": "Založ novou výsadbu",
    "plants": "rostlin",
    "dayNum": "Den {{num}}",
    "editPlanting": "Upravit osazení",
    "detail": "Detail",
    "editDate": "Uprav datum",
    "move": "Přesuň",
    "removeFromBranch": "Odeber z větve",
    "irrigationStatus": "Stav Zavlažování",
    "solenoid": "Ventil",
    "off": "Vypnuto",
    "used": "využito",
    "inactivePosition": "Neaktivní pozice",
    "positionFree": "Pozice {{slot}} (Volno)",
    "collisionAtPosition": "Kolize na pozici #{{slot}}",
    "collisionDesc": "Na této pozici se nachází více rostlin. Vyberte, kterou chcete upravit (např. přesadit):",
    "plantingStartDate": "Datum začátku výsadby",
    "dateChangeRecalc": "Změna data přepočítá stáří rostlin.",
    "removeBatchTitle": "Odeber výsadbu z větve?",
    "removeBatchDesc": "Opravdu chceš odebrat výsadbu \"{{name}}\" z této větve? Výsadba zůstane aktivní, ale nebude přiřazena k žádné větvi.",
    "deletePlantTitle": "Smazat rostlinu?",
    "deletePlantDesc": "Opravdu chceš tuto rostlinu trvale smazat?",
    "branchNotFound": "Záhon nebyl nalezen."
  },
  "gardens": {
    "title": "Zahrada",
    "subtitle": "Spravuj své zahrady",
    "create": "Založ zahradu",
    "edit": "Uprav zahradu",
    "newGarden": "Nové stanoviště",
    "editGarden": "Uprav stanoviště",
    "filterAll": "Vše",
    "emptyTitle": "Zatím tu není žádné stanoviště",
    "emptyDescription": "Vytvoř si své první stanoviště pro organizaci pěstebních oblastí.",
    "createGarden": "Vytvořit stanoviště",
    "bedCount_one": "záhon",
    "bedCount_other": "záhonů",
    "plantCount_one": "rostlina",
    "plantCount_other": "rostlin",
    "notFound": "Stanoviště nenalezeno",
    "notFoundDescription": "Toto stanoviště neexistuje nebo bylo smazáno.",
    "backToList": "Zpět na seznam",
    "backToGardens": "Zpět na stanoviště",
    "deleteConfirmTitle": "Smazat stanoviště?",
    "deleteConfirmDescription": "Opravdu chceš smazat stanoviště \"{{name}}\"? Záhony budou odpojeny.",
    "unassignConfirmTitle": "Odpojit záhon?",
    "unassignConfirmDescription": "Opravdu chceš odpojit tento záhon od stanoviště?",
    "unassign": "Odpoj",
    "unassignFromGarden": "Odpoj od stanoviště",
    "areasInGarden": "Záhony v tomto stanovišti",
    "addArea": "Přidej záhon",
    "noAssignedAreas": "Zatím nejsou žádné přiřazené záhony",
    "assignExistingArea": "Přiřaď existující záhon",
    "assignAreasTitle": "Přiřaď záhony ke stanovišti",
    "allAreasAssigned": "Všechny záhony jsou již přiřazeny k nějakému stanovišti.",
    "assignCount": "Přiřaď ({{count}})",
    "slotsCount": "slotů",
    "basicInfo": "Základní informace",
    "nameRequired": "Název *",
    "namePlaceholder": "Např. Byt na Vinohradech",
    "nameValidation": "Název je povinný",
    "gardenType": "Typ stanoviště",
    "icon": "Ikona",
    "descriptionPlaceholder": "Nepovinný popis stanoviště...",
    "location": "Lokace",
    "address": "Adresa",
    "addressPlaceholder": "Např. Vinohradská 12, Praha",
    "timezone": "Časová zóna"
  },
  "growingAreas": {
    "title": "Záhony",
    "subtitle": "Správa pěstebních záhonů",
    "create": "Nový záhon",
    "edit": "Upravit záhon"
  },
  "plants": {
    "title": "Rostliny",
    "subtitle": "Přehled vašich rostlin"
  },
  "calendar": {
    "title": "Kalendář",
    "subtitle": "Přehled plánovaných aktivit"
  },
  "analyticsDetail": {
    "timeRange": {
      "24h": "24 hodin",
      "7d": "7 dní",
      "30d": "30 dní"
    },
    "tabs": {
      "overview": "Přehled",
      "phEc": "pH & EC",
      "temperature": "Teplota"
    }
  },
  "cropPlanDetail": {
    "status": {
      "draft": "Koncept",
      "active": "Aktivní",
      "completed": "Dokončeno",
      "archived": "Archivováno"
    },
    "fallbacks": {
      "unknownPlant": "Neznámá rostlina",
      "noPlanDescription": "Plán pěstování",
      "templateNameSuffix": " - Šablona",
      "newTemplateName": "Nová šablona"
    },
    "item": {
      "placed": "Osazeno {{placed}} z {{total}}",
      "dates": {
        "sow": "Výsev:",
        "transplant": "Přesazení:",
        "harvest": "Sklizeň:"
      },
      "placements": {
        "label": "Umístění",
        "add": "Přidat",
        "positions": "{{count}} pozic",
        "executed": "Provedeno",
        "cancelled": "Zrušeno",
        "planned": "Plánováno",
        "empty": "Žádná umístění"
      }
    },
    "toasts": {
      "activated": "Plán byl úspěšně aktivován",
      "activateFailed": "Při aktivaci plánu došlo k chybě",
      "completed": "Plán byl úspěšně dokončen",
      "completeFailed": "Při dokončování plánu došlo k chybě",
      "executed": "Plán byl úspěšně realizován pro dávku: {{batchName}}",
      "executeFailed": "Při realizaci plánu došlo k chybě",
      "itemRemoved": "Položka byla úspěšně odebrána",
      "itemRemoveFailed": "Při odebírání položky došlo k chybě",
      "itemUpdated": "Položka byla úspěšně upravena",
      "itemAdded": "Položka byla úspěšně přidána",
      "itemSaveFailed": "Při ukládání položky došlo k chybě",
      "templateNameRequired": "Zadej název šablony",
      "templateSaved": "Plán byl úspěšně uložen jako šablona",
      "templateSaveFailed": "Nepodařilo se uložit šablonu",
      "placementCancelled": "Umístění bylo úspěšně zrušeno",
      "placementCancelFailed": "Při rušení umístění došlo k chybě",
      "bulkCancelled": "{{count}} umístění bylo zrušeno",
      "bulkCancelFailed": "Při hromadném rušení došlo k chybě",
      "bulkPlaced": "{{count}} umístění bylo vytvořeno",
      "bulkPlaceFailed": "Při hromadném umisťování došlo k chybě",
      "plantPlaced": "Rostlina byla úspěšně umístěna do slotu",
      "placeFailed": "Při umisťování došlo k chybě",
      "placementModeHint": "Nyní klikni na sloty v mapě pro umístění této položky"
    },
    "confirm": {
      "executePlan": {
        "title": "Realizovat plán?",
        "description": "Opravdu chceš realizovat tento plán? Vytvoří se nová dávka a rostliny budou přiřazeny do slotů."
      },
      "removeItem": {
        "title": "Odebrat položku?",
        "description": "Opravdu chceš odebrat tuto položku z plánu?"
      },
      "cancelPlacement": {
        "title": "Zrušit umístění?",
        "description": "Opravdu chceš zrušit toto umístění ve slotu?"
      },
      "bulkCancel": {
        "title": "Zrušit {{count}} umístění?",
        "description": "Opravdu chceš zrušit {{count}} vybraných umístění?"
      },
      "confirmText": "Potvrď",
      "cancelText": "Zruš"
    },
    "reality": {
      "noBatchYet": "Plán zatím nemá realizovanou dávku, reality metriky jsou nulové.",
      "exactMatch": "Skutečně založený počet přesně odpovídá plánu.",
      "overPlan": "Realita je o {{delta}} ks nad plánem.",
      "underPlan": "Do plánu chybí {{count}} ks.",
      "sectionLabel": "Plán vs realita",
      "sectionTitle": "Reality snapshot pro tento plán",
      "linkedBatches": "Napojené dávky",
      "vsLabel": "Realizace proti plánu",
      "actualVsPlanned": "{{actual}} skutečně založeno z plánovaných {{planned}} ks",
      "metrics": {
        "plan": "Plán",
        "planHelper": "Součet kvantity přes všechny položky",
        "founded": "Založeno",
        "foundedHelper": "Skutečné rostliny v navázaných dávkách",
        "germination": "Klíčení",
        "germinationHelper": "{{rate}}% z reálně založených rostlin",
        "active": "Aktivní",
        "activeHelper": "Aktuálně živé rostliny",
        "mortality": "Úhyn",
        "mortalityHelper": "{{rate}}% z reálně založených rostlin",
        "harvest": "Sklizeň",
        "harvestHelper": "Rostliny označené jako sklizené"
      },
      "warnNoStats": "Plán má realizovaná umístění, ale zatím k němu nejsou navázané statistiky. Nové realizace už ukládají a budou se zde promítat automaticky."
    },
    "stats": {
      "created": "Vytvořeno",
      "start": "Začátek",
      "items": "Položek",
      "successRate": "Úspěšnost plánu",
      "planted": "zasazeno"
    },
    "badges": {
      "items": "{{count}} položek",
      "batches": "{{count}} batchů",
      "linkedArea": "Vázáno na záhon",
      "noArea": "Bez cílového záhonu"
    },
    "header": {
      "detailTitle": "Detail plánu, realizace a navázaných dávek",
      "detailSubtitle": "Detail spojuje plánované položky, placement workflow, reality metriky i návaznost na cílový záhon."
    },
    "targetArea": {
      "label": "Cílový záhon",
      "description": "Plán je přiřazen ke konkrétní pěstební oblasti"
    },
    "actions": {
      "activate": "Aktivuj",
      "executeRun": "Realizuj dávku",
      "complete": "Dokonči",
      "saveAsTemplate": "Ulož jako šablonu",
      "settings": "Nastavení",
      "addItem": "Přidej položku"
    },
    "itemsSection": {
      "title": "Položky k výsadbě",
      "empty": {
        "title": "Zatím tu nejsou žádné položky",
        "description": "Přidej první rostlinu, kterou chceš pěstovat v tomto plánu."
      }
    },
    "visualizer": {
      "title": "Vizualizace rozmístění",
      "placementMode": "Režim umisťování:",
      "plantFallback": "Rostlina"
    },
    "templateModal": {
      "title": "Ulož plán jako šablonu",
      "description": "Šablona si zapamatuje všechny položky z tohoto plánu (druh, odrůdu a množství rostlin), ale neuloží konkrétní data a umístění ve slotech. Ideální pro opakování letos úspěšného záhonu i v dalším roce.",
      "nameLabel": "Název šablony",
      "namePlaceholder": "Např. Jarní mix na přední záhon",
      "descLabel": "Popis (volitelné)",
      "descPlaceholder": "Poznámky k této šabloně...",
      "cancel": "Zruš",
      "save": "Ulož šablonu"
    },
    "itemModal": {
      "addTitle": "Přidej {{name}} do plánu",
      "editTitle": "Uprav {{name}}",
      "itemFallback": "položku",
      "quantityLabel": "Množství rostlin",
      "notesLabel": "Poznámky (volitelné)",
      "notesPlaceholder": "Specifické požadavky, poznámky k odrůdě...",
      "datesSection": "Plánované termíny (volitelné)",
      "sowLabel": "Výsev",
      "transplantLabel": "Přesazení",
      "harvestLabel": "Sklizeň",
      "cancel": "Zruš",
      "save": "Ulož položku"
    },
    "slotModal": {
      "title": "Jakou rostlinu chceš pěstovat v tomto slotu?",
      "quickSelect": "Rychlý výběr z položek plánu:",
      "remaining": "{{remaining}} ks k osazení ({{placed}}/{{total}} osazeno)",
      "full": "Plně osazeno ({{placed}}/{{total}})",
      "or": "NEBO",
      "emptyPlan": "Plán je zatím prázdný. Vyber první rostlinu.",
      "addFromPlantOpedia": "Přidej novou rostlinu z Plant-o-Pedie"
    },
    "plantSelector": {
      "title": "Výběr plodiny do plánu"
    },
    "executeModal": {
      "title": "Realizovat plán",
      "toExecute": "K realizaci",
      "alreadyExecuted": "Již realizováno",
      "partialModeTitle": "Částečná realizace",
      "partialModeLabel": "Vybrat položky k realizaci (částečná realizace)",
      "selectedCount": "Vybrané položky: {{count}} / {{total}}",
      "selectAll": "Vybrat vše",
      "deselectAll": "Zrušit výběr",
      "noItems": "Žádné položky k realizaci",
      "slotId": "Slot: {{id}}",
      "planned": "Plánováno",
      "unknownSpecies": "Položka",
      "forceTitle": "Vynutit realizaci",
      "forceDescription": "Pokud jsou cílové sloty obsazené, stávající rostliny budou ukončeny.",
      "executeAll": "Realizovat vše",
      "executePartial": "Realizovat ({{count}})"
    },
    "notFound": {
      "error": "Plán nebyl nalezen",
      "backToList": "Zpět na seznam"
    }
  },
  "deviceManagement": {
    "title": "Správa zařízení",
    "subtitle": "Spravuj připojená zařízení a jejich nastavení",
    "addDevice": "Přidej zařízení",
    "header": {
      "title": "Fleet management připojených zařízení a OTA operací",
      "subtitle": "Přehled zahrnuje stav device fleet, restart a OTA workflow, vyhledávání i základní metadata jednotlivých jednotek."
    },
    "badges": {
      "total": "{{count}} zařízení",
      "online": "{{count}} online",
      "errors": "{{count}} v chybě",
      "filter": "Filtr: {{term}}",
      "noFilter": "Bez filtru"
    },
    "stats": {
      "total": "Celkem zařízení",
      "online": "Funguje",
      "offline": "Nepřipojeno",
      "errors": "Chyby"
    },
    "search": "Hledej zařízení...",
    "table": {
      "name": "Název",
      "deviceId": "Device ID",
      "type": "Typ",
      "status": "Status",
      "uptime": "Uptime",
      "lastSeen": "Poslední kontakt",
      "location": "Lokace",
      "actions": "Akce"
    },
    "status": {
      "online": "Funguje",
      "offline": "Nepřipojeno",
      "error": "Chyba"
    },
    "firmware": {
      "unknown": "Neznámý",
      "unknownVersion": "Neznámá"
    },
    "lastSeenNever": "Nikdy",
    "actions": {
      "restart": "Restartuj",
      "ota": "Aktualizuj",
      "edit": "Uprav",
      "delete": "Smaž"
    },
    "empty": {
      "title": "Žádná zařízení",
      "description": "Zatím nebyla registrována žádná zařízení."
    },
    "createModal": {
      "title": "Přidej nové zařízení",
      "nameLabel": "Název zařízení",
      "deviceIdLabel": "Device ID",
      "deviceIdHint": "Unikátní identifikátor zařízení",
      "typeLabel": "Typ zařízení",
      "locationLabel": "Umístění",
      "cancel": "Zruš",
      "create": "Vytvoř nové zařízení"
    },
    "editModal": {
      "title": "Uprav zařízení",
      "cancel": "Zruš",
      "save": "Ulož"
    },
    "otaModal": {
      "title": "OTA Aktualizace — {{deviceName}}",
      "currentFirmware": "Aktuální verze firmware:",
      "targetVersionLabel": "Cílová verze",
      "selectVersion": "Vyberte verzi",
      "versionStable": " (stabilní)",
      "versionBeta": " (beta)",
      "warning": "Zařízení bude aktualizováno na verzi {{version}}. Během aktualizace bude zařízení dočasně nedostupné.",
      "cancel": "Zruš",
      "start": "Spustit aktualizaci"
    },
    "deleteConfirm": {
      "title": "Smaž zařízení",
      "confirmText": "Smaž",
      "body": "Opravdu chceš smazat zařízení {{name}}? Tato akce je nevratná."
    },
    "restartConfirm": {
      "title": "Restartuj zařízení",
      "confirmText": "Restartuj",
      "body": "Opravdu chceš restartovat zařízení {{name}}?"
    },
    "errors": {
      "createFailed": "Při vytváření zařízení došlo k chybě",
      "updateFailed": "Při aktualizaci zařízení došlo k chybě",
      "deleteFailed": "Při mazání zařízení došlo k chybě",
      "restartFailed": "Při odesílání příkazu k restartu došlo k chybě",
      "otaFailed": "Při spouštění OTA aktualizace došlo k chybě"
    },
    "success": {
      "restartSent": "Příkaz k restartu byl odeslán",
      "otaStarted": "Aktualizace byla zahájena"
    }
  },
  "growingAreaDetail": {
    "activeBatches": {
      "title": "Aktivní výsadby",
      "editLayoutLabel": "Uprav osazení dávky {{name}}",
      "unknownBatch": "Neznámá dávka",
      "unknownSpecies": "Neznámý druh"
    },
    "recommendations": {
      "empty": "Žádná doporučení nejsou k dispozici",
      "emptyHint": "Zkus přidat rostliny do záhonu.",
      "scoreTitle": "Celkové skóre vhodnosti: {{score}}%",
      "difficulty": "obtížnost",
      "speciesDetail": "Detail druhu →",
      "plan": "Naplánuj",
      "sow": "Vysaď",
      "allPlans": "Všechny osevní plány"
    },
    "bulkSow": {
      "title": "Hromadný výsev",
      "close": "Zavři",
      "sowingInto": "Právě vyséváš do {{count}} vybraných slotů.",
      "batchLabel": "Várka (Batch)",
      "changeBatch": "Klikni pro změnu várky",
      "selectBatch": "Vybrat várku...",
      "seedsPerSlot": "Počet semen na slot",
      "seedsHint": "Doporučeno: 15-20 (bazalka)",
      "cancel": "Zruš",
      "sow": "Vysaď {{count}} slotů"
    },
    "areaTypes": {
      "tower": "Hydroponická věž",
      "bed": "Záhon",
      "propagation": "Sadbovač / Seeder",
      "rack": "Regálový systém",
      "other": "Pěstební plocha"
    },
    "actions": {
      "settings": "Nastavení",
      "cropPlan": "Osevní plán",
      "backToAreas": "Zpět na záhony"
    },
    "stats": {
      "title": "Stav obsazení, přesunů a provozního kontextu",
      "subtitle": "Detail záhonu propojuje obsazení slotů, doporučení, navázané batchy i akce nad jednotlivými pozicemi.",
      "areaType": "Typ oblasti",
      "totalSlots": "Celkem slotů",
      "occupied": "Obsazeno",
      "occupancy": "Obsazenost",
      "percentOccupied": "{{pct}}% obsazeno",
      "moving": "Přesun aktivní",
      "noMoving": "Bez přesunu"
    },
    "grid": {
      "title": "Mapa slotů",
      "selectionPoint": "Bod",
      "selectionRange": "Rozsah",
      "cancel": "Zruš",
      "bulk": "Hromadně",
      "selectedSlots": "Vybráno {{count}} slotů",
      "bulkSow": "Hromadně vysaď",
      "noSlots": "Žádné sloty nejsou v této oblasti",
      "bulkPhase": "Hromadná změna fáze: {{count}} rostlin",
      "changePhase": "Změň fázi"
    },
    "phases": {
      "seed": "Semínko",
      "germinated": "Vyklíčeno",
      "true_leaves": "Pravé lístky",
      "vegetative": "Vegetace",
      "flowering": "Květ",
      "fruiting": "Plod",
      "harvested": "Sklizeno",
      "dead": "Uhynulá",
      "empty": "Volno"
    },
    "aiPanel": {
      "title": "AI Doporučení"
    },
    "notFound": {
      "title": "Oblast nebyla nalezena",
      "description": "Tato pěstební oblast neexistuje nebo byla smazána.",
      "backToList": "Zpět na seznam"
    },
    "removePlant": {
      "title": "Odebrat rostlinu?",
      "description": "Opravdu chceš odebrat rostlinu \"{{name}}\" z tohoto slotu?",
      "confirmText": "Odeber",
      "cancelText": "Zruš"
    },
    "movePlant": {
      "title": "Přesadit rostlinu?",
      "description": "Přesuneš rostlinu \"{{name}}\" ze slotu {{from}}{{fromArea}} do slotu [{{row}}, {{col}}] v záhonu {{areaName}}.",
      "fromArea": " v záhonu {{name}}",
      "confirmText": "Přesadit",
      "cancelText": "Zruš"
    },
    "moveBanner": {
      "moving": "Přesouvání rostliny",
      "source": "Zdroj: {{slot}}",
      "crossArea": "Aktuálně vybíráš cíl v záhonu {{areaName}}.",
      "sameArea": "Vyber prázdný slot v tomto nebo jiném záhonu.",
      "changeArea": "Změnit záhon",
      "cancel": "Zruš"
    },
    "quickSow": {
      "title": "Přímá výsadba",
      "description": "Vytvoří novou várku {{name}} a vyseje do vybraného počtu prázdných slotů.",
      "slotsLabel": "Počet slotů",
      "seedsLabel": "Semen na slot",
      "available": "volných: {{count}}",
      "total": "celkem: {{count}} semen",
      "cancel": "Zruš",
      "sow": "Vysadit do {{count}} slotů"
    },
    "toasts": {
      "bulkSowed": "Úspěšně zaseto do {{count}} slotů",
      "bulkSowFailed": "Při hromadném výsevu došlo k chybě",
      "createBatchFailed": "Nepodařilo se vytvořit várku",
      "noEmptySlots": "Žádné prázdné sloty",
      "quickSowed": "{{name}}: zaseto do {{count}} slotů",
      "quickSowFailed": "Při přímé výsadbě došlo k chybě",
      "plantAssigned": "Rostlina přiřazena",
      "plantAssignFailed": "Při přiřazování rostliny došlo k chybě",
      "plantRemoved": "Rostlina smazána",
      "plantRemoveFailed": "Při mazání rostliny došlo k chybě",
      "plantMoved": "Rostlina přesazena do slotu {{slot}} v záhonu {{area}}",
      "plantMoveFailed": "Při přesazování rostliny došlo k chybě",
      "eventRecorded": "{{label}} zaznamenáno",
      "eventFailed": "Při ukládání události došlo k chybě",
      "incidentReported": "Incident nahlášen",
      "bulkPhaseFailed": "Při hromadné změně fáze došlo k chybě",
      "bulkPhaseChanged": "Úspěšně změněno {{count}} rostlin",
      "slotOccupied": "Slot {{slot}} je obsazený ({{occupiedBy}}). Vyber prázdný slot.",
      "slotIsSource": "Slot {{slot}} je zdrojová pozice. Vyber jiný prázdný cíl.",
      "unknownArea": "Tuto plochu se nepodařilo najít."
    }
  },
  "safetyRules": {
    "toasts": {
      "deleted": "Pravidlo smazáno",
      "deleteError": "Chyba při mazání",
      "toggled": "Stav hlídače změněn"
    },
    "modal": {
      "templateTitle": "Nový hlídač — vyberte šablonu",
      "wizardTitle": "Nastavení nového hlídače",
      "editTitle": "Upravit hlídače"
    },
    "deleteConfirm": {
      "title": "Smazat hlídače?",
      "description": "Opravdu chcete smazat tohoto hlídače? Tato akce je nevratná.",
      "confirm": "Smazat",
      "cancel": "Zrušit"
    },
    "empty": {
      "title": "Žádní hlídači",
      "description": "Vytvořte svého prvního hlídače pro automatickou ochranu systému a rostlin."
    },
    "actions": {
      "new": "Nový hlídač",
      "selectAll": "Vybrat vše",
      "deselectAll": "Zrušit vše",
      "edit": "Upravit hlídač",
      "delete": "Smazat hlídač",
      "toggle": "Přepnout pravidlo {{name}}"
    },
    "status": {
      "active": "Aktivní",
      "disabled": "Vypnuto"
    },
    "noDescription": "Bez popisu",
    "card": {
      "condition": "Podmínka",
      "action": "Akce",
      "triggered": "Spuštěno",
      "lastTriggered": "Naposledy spuštěno"
    },
    "conditionTypes": {
      "greater_than": "Větší než",
      "less_than": "Menší než",
      "between": "V rozmezí",
      "duration_exceeded": "Překročení času",
      "state_mismatch": "Neshoda stavu",
      "anomaly_detection": "Detekce anomálie",
      "predictive": "Predikce"
    },
    "actionTypes": {
      "notification": "Upozornění",
      "send_alert": "Upozornění",
      "emergency_stop": "NOUZOVÉ ZASTAVENÍ",
      "stop_pump": "Zastavit čerpadlo",
      "actuator_off": "Vypnout zařízení",
      "actuator_on": "Zapnout zařízení",
      "actuator_timed": "Časovač zařízení",
      "adjust_setting": "Upravit nastavení"
    },
    "info": {
      "heading": "Ochranná pravidla a eskalace",
      "description": "Hlídače slouží pro nouzové reakce, limity zdrojů a bezpečnostní zásahy nad aktivním zařízením.",
      "badge1": "Bezpečnostní zásahy",
      "badge2": "Eskalace a limity",
      "badge3": "Ruční i šablonové založení"
    }
  },
  "myGarden": {
    "title": "Moje zahrada",
    "subtitle": "Plochy, nádrže, výsadby a deník — vše propojené v jednom přehledu.",
    "manageAll": "Spravovat",
    "tabs": {
      "areas": "Plochy",
      "reservoirs": "Nádrže",
      "batches": "Výsadby",
      "journal": "Deník"
    },
    "areas": {
      "count": "ploch",
      "slots": "políček",
      "addArea": "Nová plocha",
      "empty": {
        "title": "Zatím žádné pěstební plochy",
        "description": "Přidej první plochu a začni sledovat svůj prostor."
      }
    },
    "reservoirs": {
      "count": "nádrží",
      "addReservoir": "Nová nádrž",
      "empty": {
        "title": "Zatím žádné nádrže",
        "description": "Přidej nádrže a napáruj k nim senzory."
      }
    },
    "batches": {
      "count": "výsadeb",
      "addBatch": "Nová výsadba",
      "col": {
        "name": "Název",
        "species": "Druh",
        "plants": "Rostliny",
        "status": "Stav",
        "started": "Zahájeno"
      },
      "empty": {
        "title": "Zatím žádné výsadby",
        "description": "Spusť novou výsadbu a sleduj průběh pěstování."
      }
    },
    "journal": {
      "count": "záznamů",
      "addEntry": "Přidat záznam",
      "open": "Otevřít deník",
      "empty": {
        "title": "Deník je prázdný",
        "description": "Záznamy z měření, dávek a péče o rostliny se zobrazí zde."
      }
    }
  },
  "interlocks": {
    "monitor": {
      "title": "Interlocky",
      "subtitle": "Přehled aktivních hardwarových a backendových ochran zařízení",
      "tabCatalog": "Katalog ochran",
      "tabActive": "Aktivní ({{count}})",
      "layerFirmware": "Firmware",
      "layerBackend": "Backend",
      "severityCritical": "Kritická",
      "severityHigh": "Vysoká",
      "severityMedium": "Střední",
      "severityLow": "Nízká",
      "statusArmed": "Připravena",
      "statusTriggered": "Spuštěna",
      "statusDisabled": "Vypnuta",
      "autoResolves": "Sám se vyřeší",
      "blocksActuators": "Blokuje výstupy: {{ids}}",
      "noActive": "Žádné aktivní interlocky",
      "noActiveDesc": "Všechny ochrany jsou v klidu.",
      "reason": "Důvod",
      "since": "Aktivní od",
      "lastFired": "Naposledy spustil",
      "overridable": "Lze přepsat",
      "notOverridable": "Nelze přepsat (firmware)",
      "edit": {
        "editBtn": "Upravit",
        "editTitle": "Upravit interlock",
        "fieldEnabled": "Aktivní",
        "fieldSeverity": "Závažnost",
        "fieldAutoResolves": "Sám se vyřeší",
        "fieldOverridable": "Lze přepsat adminem",
        "fieldParameters": "Parametry",
        "firmwareNote": "Firmware interlock — editovatelné: stav a parametry",
        "saveBtn": "Uložit",
        "saveSuccess": "Interlock upraven",
        "saveError": "Nepodařilo se uložit. Zkuste to znovu.",
        "noParams": "Žádné konfigurovatelné parametry"
      }
    },
    "log": {
      "title": "Log interlocků",
      "subtitle": "Chronologický přehled všech spuštění a vyřešení ochran",
      "noEvents": "Žádné záznamy",
      "noEventsDesc": "Žádné interlocky nebyly dosud spuštěny.",
      "resolved": "Vyřešeno",
      "active": "Aktivní",
      "loadMore": "Načíst další"
    },
    "overrides": {
      "title": "Admin přepisy",
      "subtitle": "Dočasné obejití bezpečnostních ochran (jen pro administrátory)",
      "createBtn": "Nový přepis",
      "noOverrides": "Žádné aktivní přepisy",
      "noOverridesDesc": "Momentálně nejsou aktivní žádné admin přepisy.",
      "expiresIn": "Vyprší za {{minutes}} min",
      "expired": "Vypršelo",
      "revokeBtn": "Odvolat",
      "revokeConfirm": "Opravdu chceš předčasně odvolat tento přepis?",
      "createModal": {
        "title": "Vytvořit admin přepis",
        "keys": "Klíče interlocků (vyberte)",
        "allKeys": "Všechny interlocky (*)",
        "reason": "Důvod (min. 10 znaků)",
        "reasonPlaceholder": "Proč obcházíš ochrany? (testování, emergency...)",
        "duration": "Trvání",
        "duration5": "5 minut",
        "duration15": "15 minut",
        "duration30": "30 minut",
        "duration60": "60 minut",
        "warning": "Obcházím bezpečnostní omezení systému.",
        "warningCheck": "Rozumím a potvrzuji",
        "submit": "Aktivovat přepis",
        "errorReason": "Důvod musí mít alespoň 10 znaků.",
        "errorKeys": "Vyber alespoň jeden interlock.",
        "errorConfirm": "Musíš potvrdit, že rozumíš dopadu.",
        "successCreated": "Přepis aktivován",
        "errorCreate": "Přepis se nepodařilo vytvořit. Zkuste to znovu."
      },
      "revokeSuccess": "Přepis byl odvolán",
      "revokeError": "Přepis se nepodařilo odvolat. Zkuste to znovu."
    },
    "keys": {
      "ph_mutex": "pH čerpadla — vzájemné blokování",
      "nutri_mutex": "Živiny — vzájemné blokování",
      "ph_fert_mutex": "pH + živiny — vzájemné blokování",
      "tank_low_block": "Nízká hladina nádrže",
      "suction_branch_required": "Sací čerpadlo bez větve",
      "sensor_unreliable_ph": "pH čidlo nespolehlivé",
      "sensor_unreliable_ec": "EC čidlo nespolehlivé",
      "sensor_unreliable_temp": "Teploměr nespolehlivý",
      "daily_dose_limit": "Denní limit dávkování překročen",
      "anomaly_emergency_stop": "Anomálie — nouzové zastavení",
      "calibration_stale": "Kalibrace čidla prošlá",
      "ota_in_progress": "Probíhá aktualizace firmware",
      "quiet_hours": "Tichý režim",
      "manual_override_active": "Manuální přepis aktivní",
      "device_offline": "Zařízení offline",
      "sensor_stale_data": "Čidlo neposílá data",
      "temperature_out_of_range": "Teplota mimo povolený rozsah"
    }
  },
  "service": {
    "title": "Servisní konzole",
    "tabs": {
      "status": "Stav",
      "control": "Ovládání",
      "service": "Servis"
    },
    "stopAll": "STOP vše",
    "on": "Zap",
    "off": "Vyp",
    "intensity": "Intenzita",
    "tapToCalibrate": "Klepni pro kalibraci",
    "disconnected": "odpojeno",
    "noSensors": "Žádné senzory k zobrazení",
    "calibratePh": "Kalibrovat pH",
    "calibrateEc": "Kalibrovat EC",
    "testActuators": "Test aktorů",
    "stopTest": "Zastavit test",
    "resetEmergency": "Reset nouze",
    "emergencyActive": "Nouzové zastavení je aktivní — aktory jsou vypnuté.",
    "liveHint": "Živé údaje z aktuálního zařízení",
    "temperature": "Teplota",
    "tempSensors": "teplotní čidla",
    "status": "Stav",
    "levelSensors": "hladinové čidla",
    "noLevelSensors": "Žádná hladinová data",
    "flowSensors": "průtokoměry",
    "noFlowSensors": "Žádné průtokoměry",
    "liveSummary": "Shrnutí servisu",
    "liveSummaryText": "Krátký přehled: pH / EC / teplota a stavy hladiny a průtoku.",
    "liveOn": "Aktivní",
    "liveOff": "Vypnuté",
    "rowMode": "Řádkový režim",
    "liveWindow": "5 s okno",
    "levelOk": "Hladina OK",
    "levelNok": "Hladina NOK",
    "flowRunning": "Průtok běží",
    "flowStopped": "Průtok stojí",
    "modeHintTitle": "Servisní režim",
    "modeHintBody": "Režim určuje, co je na místě bezpečné spouštět. Údržba i kalibrace blokují čerpadla a větve s rostlinami, test povoluje ruční diagnostiku.",
    "blockedInMode": "Blokováno",
    "modeDescriptionTitle": "Co dělá zvolený režim",
    "modeDescription": "Zvolený režim slouží jako pracovní profil pro konkrétní servisní úkol. Přepni ho podle činnosti, aby UI jasně ukazovalo, co je povoleno.",
    "modeGuard": "Omezení",
    "activeMode": "Aktivní",
    "pwmTitle": "PWM nastavení",
    "pwmPercent": "Výkon",
    "pwmDuration": "Čas běhu",
    "minutes": "min",
    "pwmImmediate": "Ihned",
    "pwmApply": "Spustit PWM",
    "cancel": "Zrušit",
    "modes": {
      "calibration": "Kalibrace",
      "calibrationDesc": "Senzory i čerpadla podle postupu.",
      "calibrationGuard": "Povoluje kalibrační kroky a čtečky, blokuje čerpadla a rostlinné větve.",
      "maintenance": "Údržba",
      "maintenanceDesc": "Výměna roztoku, proplach, čištění.",
      "maintenanceGuard": "Udržuje systém v bezpečném servisním stavu, bez spouštění čerpadel a větví s rostlinami.",
      "test": "Test aktorů",
      "testDesc": "Sekvenční testy, náběhy a doběhy.",
      "testGuard": "Povoluje ruční diagnostiku a testovací běhy bez automatických zásahů.",
      "emergency": "Nouzové zastavení",
      "emergencyDesc": "Stop všech aktorů v jednom místě."
    },
    "calibrationWizard": {
      "startRinse": "Spustit oplach sondy",
      "startSolutionCalibration": "Spustit kalibraci roztoku {{label}}",
      "startQc": "Spustit kontrolní měření {{label}}",
      "continue": "Pokračovat",
      "proceedToQc": "Pokračovat na kontrolu",
      "saveRecord": "Uložit záznam (nepoužije se)"
    },
    "pumpCal": {
      "title": "Kalibrace čerpadel",
      "pickHint": "Vyber dávkovací čerpadlo ke kalibraci.",
      "mlPerSec": "ml/s",
      "never": "nekalibrováno",
      "primeHint": "Napusť hadičku a připrav odměrku pod výstup.",
      "check_container": "Odměrka je pod výstupem hadičky",
      "check_tube": "Hadička je naplněná (bez vzduchu)",
      "primeRun": "Napustit linku (8 s)",
      "priming": "Napouštím…",
      "primedDone": "Linka napuštěná",
      "measureHint": "Spusť čerpadlo na daný čas, změř objem a přidej bod (ideálně 2–3 body).",
      "duration": "Doba běhu",
      "measuredMl": "Naměřený objem (ml)",
      "addPoint": "Přidat bod",
      "runDose": "Spustit dávku",
      "running": "Běží…",
      "average": "Průměr",
      "reviewHint": "Uloží se průměr z {{count}} měření jako průtok čerpadla (ml/s) a jednotlivé body do historie.",
      "previous": "Předchozí",
      "new": "Nová",
      "save": "Uložit kalibraci",
      "saving": "Ukládám…",
      "next": "Pokračovat",
      "back": "Zpět",
      "runError": "Spuštění čerpadla selhalo.",
      "saveError": "Uložení kalibrace selhalo."
    },
    "confirm": {
      "resetEmergencyTitle": "Zrušit nouzový stav?",
      "resetEmergencyBody": "Znovu se povolí ovládání veškerého hardwaru — čerpadel, ventilů, topení i ozonizéru. Ujistěte se, že je bezpečné je pustit.",
      "resetEmergencyConfirm": "Zrušit nouzový stav",
      "startTestTitle": "Spustit testovací režim?",
      "startTestBody": "Test postupně sepne aktuátory včetně čerpadel a ventilů. Nespouštějte ho, pokud máte otevřenou hydrauliku nebo pracujete na elektronice.",
      "startTestConfirm": "Spustit test"
    }
  },
  "safetyRuleForm": {
    "sections": {
      "condition": "Podmínka",
      "action": "Akce",
      "behaviour": "Chování"
    },
    "fields": {
      "ruleName": "Název pravidla",
      "ruleNamePlaceholder": "např. Ochrana čerpadla při nízké hladině",
      "description": "Popis",
      "descriptionPlaceholder": "K čemu pravidlo slouží a kdy má zasáhnout",
      "category": "Kategorie",
      "sensorType": "Typ čidla",
      "conditionType": "Typ podmínky",
      "threshold": "Mezní hodnota",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "hysteresis": "Hystereze",
      "expectedValue": "Očekávaná hodnota",
      "durationMin": "Doba trvání (min)",
      "lookbackHours": "Okno zpětného pohledu (h)",
      "lookbackHoursShort": "Okno (h)",
      "predictionHours": "Předpověď (h)",
      "stdDeviations": "Počet směrodatných odchylek",
      "actionType": "Typ akce",
      "alertLevel": "Závažnost upozornění",
      "pumpsToStop": "Čerpadla k zastavení",
      "settingName": "Název nastavení",
      "settingValue": "Hodnota nastavení",
      "cooldown": "Prodleva mezi spuštěními (s)",
      "maxTriggersPerHour": "Max. spuštění za hodinu",
      "priority": "Priorita",
      "priorityHint": "Vyšší číslo = pravidlo se vyhodnotí dřív",
      "activeFrom": "Aktivní od",
      "activeTo": "Aktivní do",
      "daysOfWeek": "Dny v týdnu",
      "oneTimeRule": "Jednorázové pravidlo",
      "oneTimeRuleDesc": "Po prvním spuštění se samo vypne"
    },
    "hints": {
      "thresholdGt": "Pravidlo se spustí, když hodnota překročí mez.",
      "thresholdLt": "Pravidlo se spustí, když hodnota klesne pod mez.",
      "between": "Pravidlo se spustí, když hodnota vyjde z rozsahu.",
      "hysteresis": "Ochrana proti překlápění sem a tam u hranice. Pravidlo zůstane aktivní, dokud se hodnota nevrátí o tuhle rezervu zpět.",
      "durationExceeded": "Spustí se, až podmínka platí nepřetržitě po celou uvedenou dobu.",
      "stateMismatch": "Hlídá, že stav zařízení odpovídá očekávání — např. že při běhu čerpadla je otevřená větev.",
      "anomalyDetection": "Porovnává hodnotu s běžným chováním čidla. Zasáhne, když se výrazně vymyká.",
      "stdDeviations": "Jak moc se hodnota musí vymykat, aby se považovala za anomálii. Nižší číslo = citlivější.",
      "predictive": "Odhaduje vývoj z posledních měření a varuje dřív, než se mez překročí.",
      "predictionHours": "Jak daleko dopředu se má vývoj odhadovat.",
      "lookbackHours": "Z jak dlouhé historie se počítá běžné chování čidla.",
      "lookbackForRegression": "Z jak dlouhé historie se počítá trend pro předpověď.",
      "cooldown": "Minimální pauza mezi dvěma spuštěními. Brání zahlcení upozorněními.",
      "rateLimiting": "Strop počtu spuštění za hodinu — pojistka proti smyčce."
    },
    "placeholders": {
      "thresholdGt": "Horní mez",
      "thresholdLt": "Dolní mez",
      "limitValue": "Mezní hodnota",
      "lowerBound": "Dolní hranice",
      "upperBound": "Horní hranice",
      "expectedValue": "Očekávaný stav",
      "minutes": "Minuty",
      "predictionLimit": "Mez pro předpověď"
    },
    "alertLevels": {
      "auto": "Automaticky podle závažnosti"
    },
    "errors": {
      "required": "Vyplňte prosím toto pole."
    },
    "toasts": {
      "created": "Pravidlo bylo vytvořeno.",
      "updated": "Pravidlo bylo uloženo.",
      "createError": "Pravidlo se nepodařilo vytvořit. Zkuste to znovu.",
      "updateError": "Změny se nepodařilo uložit. Zkuste to znovu."
    }
  },
  "branchDetail": {
    "activeBatches": {
      "addBatch": "Přidat další dávku",
      "batchActions": "Další akce s dávkou",
      "canonicalArea": "Hlavní pohled na tuto starší větev je nyní {{name}}.",
      "createBatch": "Vytvořit novou dávku",
      "day": "{{day}}. den",
      "detail": "Detail",
      "editDate": "Upravit datum",
      "empty": "Na této větvi nic neroste.",
      "goToAreas": "Přejít na pěstební plochy",
      "migrationNote": "Výsadba a přesazování se spravuje v detailu pěstební plochy.",
      "move": "Přesunout",
      "noCanonicalArea": "Hlavní pohled je nyní v sekci Pěstební plochy, ne ve starším detailu větve.",
      "openArea": "Otevřít detail plochy",
      "plantCount": "{{count}} rostlin",
      "removeBatch": "Odebrat z větve",
      "title": "Aktivní rostliny a dávky"
    },
    "back": "Zpět",
    "close": "Zavřít",
    "collision": {
      "description": "Na této pozici je víc rostlin. Vyberte tu, kterou chcete upravit (např. přesadit):",
      "plantInfo": "Stav: {{status}}, {{substrate}}",
      "title": "Kolize na pozici č. {{slot}}",
      "unknownSubstrate": "Neznámý"
    },
    "controls": {
      "lighting": "Osvětlení",
      "title": "Ovládání větve",
      "valves": "Ventily"
    },
    "deletePlant": {
      "cancel": "Zrušit",
      "confirm": "Smazat",
      "description": "Opravdu chcete tuto rostlinu trvale smazat?",
      "title": "Smazat rostlinu?"
    },
    "editDate": {
      "cancel": "Zrušit",
      "hint": "Změna data přepočítá stáří rostlin.",
      "save": "Uložit",
      "title": "Datum založení dávky"
    },
    "history": {
      "empty": "Žádná historie.",
      "title": "Historie dávky"
    },
    "irrigation": {
      "off": "Vypnuto",
      "solenoid": "Ventil",
      "title": "Stav zavlažování"
    },
    "noDescription": "Bez popisu",
    "notFound": "Větev nenalezena.",
    "rack": {
      "dead": "Uhynulá",
      "healthy": "Zdravá",
      "sick": "Nemocná",
      "slotFree": "Pozice {{slot}} (volná)",
      "slotOccupied": "Pozice {{slot}}",
      "title": "Pohled na regál",
      "inactiveSlot": "Neaktivní pozice",
      "occupancy": "obsazeno {{used}} z {{total}}"
    },
    "removeBatch": {
      "cancel": "Zrušit",
      "confirm": "Odebrat",
      "description": "Opravdu chcete odebrat dávku {{name}} z této větve? Dávka zůstane aktivní, ale nebude přiřazená k žádné větvi.",
      "title": "Odebrat dávku z větve?"
    },
    "targets": {
      "humidity": "Vlhkost",
      "light": "Světlo",
      "subtitle": "Podle aktivních receptur",
      "temperature": "Teplota",
      "title": "Cílové podmínky"
    },
    "toasts": {
      "batchRemoveFailed": "Dávku se nepodařilo odebrat",
      "batchRemoved": "Dávka byla odebrána z větve",
      "dateUpdateFailed": "Datum se nepodařilo změnit",
      "dateUpdated": "Datum založení bylo změněno",
      "plantDeleteFailed": "Rostlinu se nepodařilo smazat",
      "plantDeleted": "Rostlina byla smazána"
    }
  },
  "growingAreaList": {
    "actions": {
      "newArea": "Nová plocha",
      "newGarden": "Nová zahrada"
    },
    "allDevices": "Všechna zařízení",
    "deleteArea": {
      "cancel": "Zrušit",
      "confirm": "Smazat",
      "description": "Opravdu chcete tuto plochu smazat? Akci nelze vrátit zpět.",
      "title": "Smazat plochu?"
    },
    "deleteGarden": {
      "cancel": "Zrušit",
      "confirm": "Smazat zahradu",
      "description": "Opravdu chcete smazat zahradu {{name}}? Plochy uvnitř zůstanou, jen ztratí přiřazení.",
      "title": "Smazat zahradu?"
    },
    "empty": {
      "addArea": "Přidat samostatnou plochu",
      "createGarden": "Vytvořit zahradu",
      "description": "Začněte vytvořením zahrady (např. Skleník, Byt), nebo přidejte samostatnou plochu.",
      "title": "Zatím žádné plochy ani zahrady"
    },
    "filterLabel": "Filtrovat podle zařízení",
    "gardenModal": {
      "cancel": "Zrušit",
      "create": "Vytvořit zahradu",
      "createDescription": "Zahrada pomáhá seskupit plochy podle místa nebo způsobu pěstování.",
      "createFailed": "Zahradu se nepodařilo vytvořit.",
      "createTitle": "Vytvořit zahradu",
      "editDescription": "Upravte název a typ, ať přehled odpovídá skutečnosti.",
      "editTitle": "Upravit zahradu",
      "nameLabel": "Název zahrady",
      "namePlaceholder": "Např. Skleník, Balkon nebo Horní police",
      "nameRequired": "Zadejte prosím název zahrady.",
      "save": "Uložit změny",
      "saveFailed": "Zahradu se nepodařilo uložit.",
      "typeLabel": "Typ zahrady"
    },
    "gardenTypes": {
      "greenhouse": "Skleník",
      "indoor": "Vnitřní",
      "outdoor": "Venkovní"
    },
    "overview": {
      "activeView": "Zobrazeno: {{device}}",
      "all": "Vše",
      "areasCount": "{{count}} ploch",
      "devicesCount": "{{count}} zařízení",
      "filtered": "Filtrováno",
      "gardensCount": "{{count}} zahrad",
      "title": "Přehled ploch"
    },
    "quickActions": {
      "cropPlans": "Plány pěstování",
      "cropPlansDesc": "Spravovat plány",
      "recommendations": "Doporučení",
      "recommendationsDesc": "Co pěstovat",
      "recommendationsHint": "Vyberte zařízení ve filtru výše"
    },
    "subtitle": "Spravujte své zahrady a pěstební plochy",
    "title": "Moje pěstební plochy"
  },
  "userManagement": {
    "actions": {
      "add": "Přidat uživatele"
    },
    "createModal": {
      "cancel": "Zrušit",
      "create": "Vytvořit",
      "passwordLabel": "Heslo",
      "title": "Vytvořit nového uživatele"
    },
    "deleteConfirm": {
      "confirmText": "Smazat",
      "description": "Opravdu chcete tohoto uživatele smazat? Akci nelze vrátit zpět.",
      "title": "Smazat uživatele?"
    },
    "editModal": {
      "cancel": "Zrušit",
      "save": "Uložit",
      "title": "Upravit uživatele"
    },
    "empty": {
      "description": "Zatím tu nejsou žádní uživatelé.",
      "title": "Žádní uživatelé"
    },
    "errors": {
      "createFailed": "Uživatele se nepodařilo vytvořit",
      "deleteFailed": "Uživatele se nepodařilo smazat",
      "updateFailed": "Uživatele se nepodařilo uložit"
    },
    "overview": {
      "activeFilter": "Filtr: {{term}}",
      "adminCount": "{{count}} správců",
      "noFilter": "Bez filtru",
      "operatorCount": "{{count}} obsluhy",
      "subtitle": "Tato stránka spojuje vyhledávání uživatelů, role i správu účtů do jedné tabulky.",
      "title": "Správa účtů, rolí a oprávnění",
      "userCount": "{{count}} účtů"
    },
    "roles": {
      "admin": "Správce",
      "device": "Zařízení",
      "operator": "Obsluha",
      "user": "Uživatel",
      "viewer": "Pozorovatel"
    },
    "search": "Hledat uživatele…",
    "subtitle": "Spravujte uživatelské účty a jejich oprávnění",
    "table": {
      "actions": "Akce",
      "created": "Vytvořen",
      "deleteTitle": "Smazat",
      "editTitle": "Upravit",
      "lastLogin": "Poslední přihlášení",
      "never": "Nikdy"
    },
    "title": "Správa uživatelů"
  }
}
